import { Button } from 'semantic-ui-react'
import styled from 'styled-components'

export const BrandHeader = styled.div`
  padding: 0 48px 24px 48px;
`

export const BrandTitle = styled.p`
  color: #2b2b2b;
  leading-trim: both;
  text-edge: cap;
  font-family: Inter;
  font-size: 24px;
  letter-spacing: -0.48px;
  font-style: normal;
  font-weight: 500;
  text-align: left;
  line-height: 32px;
  margin-bottom: 16px;
  -webkit-font-smoothing: antialiased;
`

export const BrandSubtitle = styled.p`
  margin-bottom: 0px;
  color: #2b2b2b;
  leading-trim: both;
  text-edge: cap;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
  -webkit-font-smoothing: antialiased;
  letter-spacing: -0.08px;
`

export const AuthSection = styled.div`
  margin-bottom: 24px;
  padding: 0 48px 16px;
`

export const HelpSection = styled.div`
  margin-bottom: 24px;
  padding: 0 48px;
`

export const HelpText = styled.p`
  color: ${(props) => (props.$isDrayNow ? '#808080' : '#9da7ba')};
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const HelpSpan = styled.span`
  color: ${(props) => (props.$isDrayNow ? '#808080' : '#9da7ba')};
  leading-trim: both;
  text-edge: cap;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const LegalLinks = styled.div`
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  a {
    text-decoration: underline;
    cursor: pointer;
    transition: 0.2s ease color;

    &:hover {
      text-decoration: underline;
    }
  }
`

export const LoginButton = styled(Button)`
  border-radius: 8px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  padding: 0px 16px;
  height: 48px;
  margin: 0px;
`
